import { createSlice } from "@reduxjs/toolkit";
import {
  getAdditionalFees,
  addNewAdditionalFee,
  updateAdditionalFee,
  deleteAdditionalFee,
} from "./thunk";

export const initialState = {
  additionalfees: [],
  error: {},
};

const additionalFeesSlice = createSlice({
  name: "addfee",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAdditionalFees.fulfilled, (state, action) => {
      state.additionalfees = action.payload;
      state.isAdditionalFeesFailed = false;
      state.isAdditionalFeesSuccess = true;
    });

    builder.addCase(getAdditionalFees.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isAdditionalFeesFailed = true;
      state.isAdditionalFeesSuccess = false;
    });

    builder.addCase(addNewAdditionalFee.fulfilled, (state, action) => {
      state.additionalfees.push(action.payload);
      state.isAdditionalFeeAdd = true;
      state.isAdditionalFeeAddFail = false;
    });

    builder.addCase(addNewAdditionalFee.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isAdditionalFeeAdd = false;
      state.isAdditionalFeeAddFail = true;
    });

    builder.addCase(updateAdditionalFee.fulfilled, (state, action) => {
      state.additionalfees = state.additionalfees.map((additionalfee) =>
        additionalfee._id.toString() === action.payload._id.toString()
          ? { ...additionalfee, ...action.payload }
          : additionalfee
      );
      state.isAdditionalFeeUpdate = true;
      state.isAdditionalFeeUpdateFail = false;
    });

    builder.addCase(updateAdditionalFee.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isAdditionalFeeUpdate = false;
      state.isAdditionalFeeUpdateFail = true;
    });

    // builder.addCase(deleteAdditionalFee.fulfilled, (state, action) => {
    //   const payloadFee = action.payload?.additionalfee;

    //   const deletedId =
    //     typeof payloadFee === "string" ? payloadFee : payloadFee?._id;

    //   if (!deletedId) return;

    //   state.additionalfees = (state.additionalfees || []).filter(
    //     (additionalfee) =>
    //       additionalfee?._id?.toString() !== deletedId.toString()
    //   );

    //   state.isCompanyDelete = true;
    //   state.isCompanyDeleteFail = false;
    // });

    builder.addCase(deleteAdditionalFee.fulfilled, (state, action) => {
      state.additionalfees = (state.additionalfees || []).filter(
        (addfee) => addfee._id.toString() !== action.payload.addfee.toString()
      );
      state.isAdditionalFeeDelete = true;
      state.isAdditionalFeeDeleteFail = false;
    });

    builder.addCase(deleteAdditionalFee.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isAdditionalFeeDelete = false;
      state.isAdditionalFeeDeleteFail = true;
    });
  },
});

export default additionalFeesSlice.reducer;
